import React from "react";

import { SvgComponentProps } from "../GenericIconType";
import { SvgWrapper } from "../styles";

const Plus = (props: SvgComponentProps) => {
  const { width = 20, height = 20, color = "#FFFFFF", widthBoxView, heightBoxView } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${widthBoxView || width} ${heightBoxView || height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 4.16667V15.8333M4.16667 10H15.8333"
          stroke={color}
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgWrapper>
  );
};

export default Plus;
